/* eslint-disable no-duplicate-imports */
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/tm-summary-tile';
import { type SummaryTileVm } from '@treasury/presentation/components/tm-summary-tile';
import { css, html, nothing, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';

export type SummaryTile = {
    status: string;
    count: number;
    totalAmount: number | TemplateResult;
};

export const tagName = 'list-summary-bar';

@customElement(tagName)
export class ListSummaryBar extends TmBaseComponent {
    @property()
    public summary: SummaryTile[] = [];

    @property()
    public selectedTile?: SummaryTileVm;

    protected render() {
        if (!this.summary || this.summary.length === 0) {
            return nothing;
        }
        const tiles = this.summary.map(tile => this.mapTile(tile));
        return html`<div class="grid gap-4 grid-cols-5 px-2 py-2">
            ${tiles.map(
                tile =>
                    html`<tm-summary-tile
                        .summaryTile=${tile}
                        .isSelected=${this.selectedTile?.id === tile.id}
                        @tileClicked=${() => {
                            this.dispatchEvent(new CustomEvent('tileClicked', { detail: tile }));
                            tile.isSelected = !tile.isSelected;
                        }}
                    ></tm-summary-tile>`
            )}
        </div>`;
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: block;
                }
            `,
        ];
    }

    private mapTile(summaryTile: SummaryTile): SummaryTileVm {
        return {
            id: summaryTile.status,
            title: summaryTile.status,
            count: summaryTile.count,
            totalAmount:
                typeof summaryTile.totalAmount === 'number'
                    ? summaryTile.totalAmount.toLocaleString('en-US', {
                          style: 'currency',
                          currency: 'USD',
                      })
                    : summaryTile.totalAmount,
            isSelected: false,
        };
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: ListSummaryBar;
    }
}
